// extracted by extract-css-chunks-webpack-plugin
module.exports = {"currentPrice":"currentPrice_ZLxNR","discounted":"discounted_OvFRw"};